import React, { useContext, useState } from 'react';
import './../styles/App.css';
import MyInput from './UI/MyInput/MyInput';
import MyButton from './UI/MyButton/MyButton';
import { createPatient } from '../API/patientApi';
import { createTherapy, createTherapyComment } from '../API/therapyApi';
import { createIllnessProfile } from '../API/illnessProfileApi';
import { ms2format } from '../utils/date';
import { MainContext } from '..';

const AddNewPatient = ({ setAddPatientVisible }) => {
    const { medicalStore } = useContext(MainContext);

    const [surname, setSurname] = useState('');
    const [name, setName] = useState('');
    const [patronymic, setPatronymic] = useState('');
    const [birthDate, setBirthDate] = useState('');
    const [selectedGender, setSelectedGender] = useState('');
    // const [rep_SNP, setRep_SNP] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [diagnosis, setDiagnosis] = useState('');
    const [chooseDiagnosis, setChooseDiagnosis] = useState(-1);
    const [comment, setComment] = useState('');
    const [deviceId, setDeviceId] = useState('');
    const [minSpO2, setMinSpO2] = useState(0);
    const [maxSpO2, setMaxSpO2] = useState(0);
    const [minO2Flow, setMinO2Flow] = useState(0);
    const [maxO2Flow, setMaxO2Flow] = useState(0);
    const [initialO2, setInitialO2] = useState(0);
    const [flow_response_latency, setFlow_response_latency] = useState(0);
    const [flow_speed_change, setFlow_speed_change] = useState(0);

    const cleanInputs = () => {
        setSurname('');
        setName('');
        setPatronymic('');
        setBirthDate('');
        setSelectedGender('');
        // setRep_SNP('');
        setPhone('');
        setEmail('');
        setDiagnosis('');
        setChooseDiagnosis(-1);
        setComment('');
        setDeviceId('');
        setMinSpO2(0);
        setMaxSpO2(0);
        setMinO2Flow(0);
        setMaxO2Flow(0);
        setInitialO2(0);
        setFlow_response_latency(0);
        setFlow_speed_change(0);
    };

    const addNewPatient = async () => {
        try {
            const patientData = await createPatient(
                name,
                surname,
                patronymic,
                birthDate,
                email,
                phone,
                selectedGender
            );
            let illnessProfileData = { id: chooseDiagnosis };
            if (chooseDiagnosis === -1) {
                illnessProfileData = await createIllnessProfile(
                    diagnosis,
                    minSpO2,
                    maxSpO2,
                    minO2Flow,
                    maxO2Flow,
                    initialO2,
                    flow_response_latency,
                    flow_speed_change
                );
            }
            const therapyData = await createTherapy(
                ms2format(Date.now()),
                deviceId,
                illnessProfileData.id,
                patientData.id
            );
            console.log(therapyData.id)
            const commentData = await createTherapyComment(therapyData.id, comment);
            setAddPatientVisible(false);
        } catch (e) {
            console.log(e);
            const errorData = e.response?.data;
            const errorMessage =
                errorData?.error ||
                errorData?.detail ||
                (errorData && typeof errorData === 'object'
                    ? Object.entries(errorData)
                        .map(([field, messages]) => `${field}: ${Array.isArray(messages) ? messages.join(', ') : messages}`)
                        .join('\n')
                    : null) ||
                'Не удалось добавить пациента. Проверьте введённые данные и попробуйте снова.';
            alert(errorMessage);
        }
    };

    return (
        <div className="addNewPatient">
            {/* <div style={{ backgroundColor: 'rgb(14, 0, 107)', width: '100%', height: '5px' }} /> */}
            <div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '50%',
                            padding: 20,
                            borderRight: '2px solid rgb(14, 0, 107)',
                        }}
                    >
                        <h2 style={{ textAlign: 'center' }}>Личные данные пациента</h2>
                        <label htmlFor="surname">Фамилия</label>
                        <MyInput
                            style={{ marginBottom: 10 }}
                            id="surname"
                            name="patient_surname"
                            value={surname}
                            onChange={(e) => setSurname(e.target.value)}
                        />
                        <label htmlFor="name">Имя</label>
                        <MyInput
                            id="name"
                            name="patient_name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                        <label htmlFor="patronymic">Отчество</label>
                        <MyInput
                            id="patronymic"
                            name="patient_patronymic"
                            value={patronymic}
                            onChange={(e) => setPatronymic(e.target.value)}
                        />
                        <label htmlFor="birth_date">Дата рождения</label>
                        <MyInput
                            id="birth_date"
                            name="patient_birth_date"
                            type="date"
                            value={birthDate}
                            onChange={(e) => setBirthDate(e.target.value)}
                        />
                        <label>Пол</label>
                        <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10 }}>
                            <MyInput
                                id="male"
                                name="gender"
                                value="M"
                                type="radio"
                                hidden
                                checked={selectedGender === 'M'}
                                onChange={(e) => setSelectedGender(e.target.value)}
                            />
                            <label
                                htmlFor="male"
                                className={
                                    selectedGender === 'M'
                                        ? 'addNewPatientGenderBtns Male'
                                        : 'addNewPatientGenderBtns'
                                }
                            >
                                Мужской
                            </label>
                            <MyInput
                                id="female"
                                name="gender"
                                value="F"
                                type="radio"
                                hidden
                                checked={selectedGender === 'F'}
                                onChange={(e) => setSelectedGender(e.target.value)}
                            />
                            <label
                                htmlFor="female"
                                className={
                                    selectedGender === 'F'
                                        ? 'addNewPatientGenderBtns Female'
                                        : 'addNewPatientGenderBtns'
                                }
                            >
                                Женский
                            </label>
                        </div>
                        <label htmlFor="phone">Мобильный телефон</label>
                        <MyInput
                            id="phone"
                            name="phone"
                            type="tel"
                            autoComplete="tel"
                            placeholder="+71234567890"
                            inputMode="numeric"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                        />
                        <label htmlFor="email">Электронная почта</label>
                        <MyInput
                            id="email"
                            name="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        {/* <label htmlFor="photo">Фотография</label>
                        <MyInput
                            id="photo"
                            name="patient_photo"
                            type="file"
                        /> */}
                        <label>Выберите диагноз</label>
                        <select
                            style={{
                                width: '100%',
                                boxSizing: 'border-box',
                                padding: '5px 15px',
                                border: '1px solid rgb(14, 0, 107)',
                                borderRadius: '5px',
                                backgroundColor: 'rgba(248, 248, 248, 1)',
                            }}
                            onChange={(e) => setChooseDiagnosis(e.target.value)}
                        >
                            <option value={-1}>-- Выберите диагноз--</option>
                            {medicalStore.illnessProfiles.map((illnessProfile) => (
                                <option key={illnessProfile.id} value={illnessProfile.id}>
                                    {illnessProfile.title}
                                </option>
                            ))}
                        </select>
                        <label htmlFor="deviceId">ID устройства</label>
                        <MyInput
                            id="deviceId"
                            name="deviceId"
                            value={deviceId}
                            onChange={(e) => setDeviceId(e.target.value)}
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '50%',
                            padding: 20,
                            borderLeft: '2px solid rgb(14, 0, 107)',
                        }}
                    >
                        {/* <h2 style={{ textAlign: 'center' }}>Контактные данные представителя</h2> */}
                        {/* <label htmlFor="rep_SNP">ФИО представителя</label>
                        <MyInput
                            id="rep_SNP"
                            name="rep_SNP"
                            value={rep_SNP}
                            onChange={(e) => setRep_SNP(e.target.value)}
                        /> */}
                        {/* <label htmlFor="phone">Мобильный телефон</label>
                        <MyInput
                            id="phone"
                            name="rep_phone"
                            type="tel"
                            autoComplete="tel"
                            placeholder="7 123 456 78-90"
                            inputMode="numeric"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                        />
                        <label htmlFor="email">Электронная почта</label>
                        <MyInput
                            id="email"
                            name="rep_email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        /> */}
                        <h2 style={{ textAlign: 'center' }}>Создайте новый диагноз</h2>
                        <label htmlFor="diagnosis">Название диагноза</label>
                        <MyInput
                            id="diagnosis"
                            name="patient_diagnosis"
                            value={diagnosis}
                            onChange={(e) => setDiagnosis(e.target.value)}
                        />

                        <label htmlFor="doctor_comments">Комментарий врача</label>
                        <MyInput
                            id="doctor_comments"
                            name="doctor_comments"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                        />
                        <label htmlFor="minSpO2">Минимальная сатурация, %</label>
                        <MyInput
                            id="minSpO2"
                            name="minSpO2"
                            value={minSpO2}
                            type="number"
                            onChange={(e) => setMinSpO2(e.target.value)}
                        />
                        <label htmlFor="maxSpO2">Максимальная сатурация, %</label>
                        <MyInput
                            id="maxSpO2"
                            name="maxSpO2"
                            value={maxSpO2}
                            type="number"
                            onChange={(e) => setMaxSpO2(e.target.value)}
                        />
                        <label htmlFor="minO2Flow">Минимальный поток смеси, литров в минуту</label>
                        <MyInput
                            id="minO2Flow"
                            name="minO2Flow"
                            value={minO2Flow}
                            type="number"
                            onChange={(e) => setMinO2Flow(e.target.value)}
                        />
                        <label htmlFor="maxO2Flow">Максимальный поток смеси, литров в минуту</label>
                        <MyInput
                            id="maxO2Flow"
                            name="maxO2Flow"
                            value={maxO2Flow}
                            type="number"
                            onChange={(e) => setMaxO2Flow(e.target.value)}
                        />
                        <label htmlFor="initialO2">Начальный поток смеси, литров в минуту</label>
                        <MyInput
                            id="initialO2"
                            name="initialO2"
                            value={initialO2}
                            type="number"
                            onChange={(e) => setInitialO2(e.target.value)}
                        />
                        <label htmlFor="flow_response_latency">Задержка реакции потока</label>
                        <MyInput
                            id="flow_response_latency"
                            name="flow_response_latency"
                            value={flow_response_latency}
                            type="number"
                            onChange={(e) => setFlow_response_latency(e.target.value)}
                        />
                        <label htmlFor="initflow_speed_changeialO2">
                            Изменение скорости потока
                        </label>
                        <MyInput
                            id="flow_speed_change"
                            name="flow_speed_change"
                            value={flow_speed_change}
                            type="number"
                            onChange={(e) => setFlow_speed_change(e.target.value)}
                        />
                        {/* <div>ID пациента</div>
                        <MyButton
                            onClick={() => alert('Нажата кнопка "Сгенерировать"')}
                        >
                            Сгенерировать
                        </MyButton>
                        <div>QR-код для создания аккаунта пациента</div>
                        <MyButton
                            onClick={() => alert('Нажата кнопка "Сгенерировать"')}
                        >
                            Сгенерировать
                        </MyButton> */}
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <div style={{ display: 'flex', width: '50%', justifyContent: 'right' }}>
                    <MyButton style={{ margin: 10 }} onClick={addNewPatient}>
                        Добавить
                    </MyButton>
                </div>
                <div style={{ display: 'flex', width: '50%', justifyContent: 'left' }}>
                    <MyButton
                        style={{ margin: 10, color: 'rgba(135, 21, 21, 1)' }}
                        onClick={() => {
                            setAddPatientVisible(false);
                            cleanInputs();
                        }}
                    >
                        Закрыть
                    </MyButton>
                </div>
            </div>
        </div>
    );
};

export default AddNewPatient;
